<div class="flex-container fhd-toast {{className}}">
    <ng-content>
    <!--message-->
    </ng-content>
</div>